import React from "react"
import { Divider } from "antd"
import PropTypes from "prop-types"
import collect from "collect.js"
import CompanyUserAccessSelect from "./CompanyUserAccessSelect"
import CompanyUserAccessListItem from "./CompanyUserAccessListItem"
import { ROLE_MANDU_ADMIN } from "../../../../utils/constants"

const clearSelector = (props) => {
  const { dataSource, items } = props

  const collectCompanies = collect(items).filter(
    (item) =>
      collect(dataSource)
        .where("id_company", item.id_company)
        .count() === 0
  )

  return collectCompanies.toArray()
}

const CompanyUserAccess = (props) => {
  const { id_role } = props.currentData
  const checkUndefined = id_role == null

  const checkIfAdministrator = checkUndefined
    ? false
    : id_role === ROLE_MANDU_ADMIN

  return (
    <div style={{ display: checkIfAdministrator === false ? "none" : "block" }}>
      <Divider
        style={{
          margin: "1rem -24px",
          width: "calc(100% + 48px)",
          display: props.isNew ? "block" : "none",
        }}
      />
      <CompanyUserAccessSelect {...props} options={clearSelector(props)} />
      <CompanyUserAccessListItem {...props} />
    </div>
  )
}

CompanyUserAccess.propTypes = {
  id_role: PropTypes.number,
  isNew: PropTypes.bool,
}

export default CompanyUserAccess
